// extracted by mini-css-extract-plugin
module.exports = {"container":"styles_container__VBOMw","title":"styles_title__3_WTq","btn":"styles_btn__1N0ak"};